import { useCurrentUser } from "components/context/user/UserContext"
import AboutYou from "components/views/fle/aboutyou/AboutYou"
import AboutYourPartner from "components/views/fle/AboutYourPartner"
import { AboutYouFlowContextProvider } from "components/views/fle/context/AboutYouFlowContext"
import React from "react"
import { Switch, Route, Redirect } from "react-router"
import { ThemeProvider } from "styled-components"
import { fleFormTheme } from "themes/formThemes"
import { useBodyClass } from "utils/Hooks"
import { CarrotPlansFlowContainer } from "."

function ProtectFlow({ children }): JSX.Element {
  const { carrotPlansRoutingCompleted, benefitStarted } = useCurrentUser()

  if (carrotPlansRoutingCompleted || !benefitStarted) {
    return <Redirect to="/" />
  }
  return children
}

export function CarrotPlansRouter(): JSX.Element {
  useBodyClass("bg-warm-gray")

  return (
    <ThemeProvider theme={fleFormTheme}>
      <AboutYouFlowContextProvider>
        <Switch>
          <Route exact path="/carrot-plans">
            <Redirect to="/carrot-plans/about-you" />
          </Route>
          <Route path="/carrot-plans/about-you">
            <ProtectFlow>
              <AboutYou />
            </ProtectFlow>
          </Route>
          <Route path="/carrot-plans/partner">
            <ProtectFlow>
              <AboutYourPartner />
            </ProtectFlow>
          </Route>
          <Route path="/carrot-plans/journey">
            <ProtectFlow>
              <CarrotPlansFlowContainer />
            </ProtectFlow>
          </Route>
        </Switch>
      </AboutYouFlowContextProvider>
    </ThemeProvider>
  )
}
